import React from 'react';
import type { BombiixIconProps } from './types';

/** Bombiix Partner Rights icon. Exported from Figma (Bombiix 2026). */
const PartnerRightsIcon: React.FC<BombiixIconProps> = ({ size = 20, ...rest }) => (
  <svg width={size} height={size} viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" {...rest}>
    <path d="M14 7V24M14 24H11M14 24H17" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M23 15L20.5 10L18 15" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M10 15L7.5 10L5 15" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M6 10H7.0482C8.31166 10 9.5375 9.471 10.5241 8.5C12.5562 6.5 15.4438 6.5 17.4759 8.5C18.4625 9.471 19.6883 10 20.9518 10H22"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M20.5 19C21.8547 19 23.0344 18.1663 23.6473 16.9349C23.978 16.2702 24.1434 15.9379 23.8415 15.469C23.5396 15 23.04 15 22.0407 15H18.9593C17.96 15 17.4604 15 17.1585 15.469C16.8566 15.9379 17.022 16.2702 17.3527 16.9349C17.9656 18.1663 19.1453 19 20.5 19Z"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <path
      d="M7.5 19C8.85471 19 10.0344 18.1663 10.6473 16.9349C10.978 16.2702 11.1434 15.9379 10.8415 15.469C10.5396 15 10.04 15 9.04075 15H5.95925C4.96 15 4.46038 15 4.15849 15.469C3.85661 15.9379 4.02198 16.2702 4.35273 16.9349C4.96558 18.1663 6.14528 19 7.5 19Z"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <path
      d="M15.5 5.5C15.5 6.32843 14.8284 7 14 7C13.1716 7 12.5 6.32843 12.5 5.5C12.5 4.67157 13.1716 4 14 4C14.8284 4 15.5 4.67157 15.5 5.5Z"
      stroke="currentColor"
      strokeWidth="1.5"
    />
  </svg>
);

export default PartnerRightsIcon;
